module.exports = __webpack_public_path__ + "static/contact-f48b682efc1574ffb9664c9ef0be720c.svg";